import { useTenant } from '../../context/TenantContext.jsx';
import { HeaderSlot } from '../../registry/slots/HeaderSlot.jsx';

export function ShellHeader({
  route,
  onNavigate,
  cartCount = 0,
  onOpenCart,
  onSearch,
  variant,
  onOpenCopilot,
  ...props
}) {
  const { tenant } = useTenant();

  const currentPath = typeof window !== 'undefined'
    ? `${window.location.pathname}${window.location.search}`
    : (route?.name === 'catalog' ? '/catalog' : '/');

  const handleSearch = (query) => {
    if (onSearch) {
      onSearch(query);
    } else if (onNavigate && query) {
      onNavigate(`/catalog?search=${encodeURIComponent(query)}`);
    }
  };

  return (
    <HeaderSlot
      variant={variant || tenant?.settings?.layout_header}
      tenant={tenant}
      cartCount={cartCount}
      onOpenCart={onOpenCart}
      onNavigate={onNavigate}
      onSearch={handleSearch}
      currentPath={currentPath}
      onOpenCopilot={onOpenCopilot}
      {...props}
    />
  );
}
